import React from "react";
import TextField from "@material-ui/core/TextField";

// Converts any date-like value to a "YYYY-MM-DD" string safe for <input type="date">.
// Handles: "YYYY-MM-DD" strings, ISO timestamps, Date objects, dayjs objects, moment objects.
// Avoids UTC-midnight off-by-one by using local getters for object types and slicing for strings.
function toLocalDateString(value) {
  if (!value) return "";
  if (typeof value === "string") {
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      const dateStr = value.slice(0, 10);
      return dateStr.startsWith("0001") ? "" : dateStr;
    }
    return "";
  }
  // Date, dayjs, or moment objects — use local getters so no UTC midnight shift
  const d =
    typeof value.toDate === "function"
      ? value.toDate()
      : value instanceof Date
      ? value
      : null;
  if (!d || isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export const DatePicker = ({
  label,
  value,
  error,
  onChange,
  required,
  fullWidth,
  minDate,
  maxDate,
  ...rest
}) => {
  return (
    <TextField
      label={label}
      type="date"
      value={toLocalDateString(value)}
      onChange={(e) => onChange?.(e.target.value)}
      required={required}
      error={error}
      variant="outlined"
      size="small"
      fullWidth={fullWidth !== false}
      InputLabelProps={{ shrink: true }}
      inputProps={{
        min: minDate ? toLocalDateString(minDate) : undefined,
        max: maxDate ? toLocalDateString(maxDate) : undefined,
      }}
      {...rest}
    />
  );
};
